import { createElement } from "react";
import { Trans } from "react-i18next";
import { deleteHttp } from "@common/api/apiShared";
import { Result } from "@common/api/result";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { IDeleteRiskObservationDialog } from "./DeleteRiskObservationDialog";

export function useDeleteRiskObservationDialogDataMapping(props: IDeleteRiskObservationDialog) {
    const snackbar = useDotLegalSnackbar();

    const removeMutation = useDotLegalMutation(remove);
    const removeObservation = () => {
        removeMutation.mutateAsync(undefined, {
            onSuccess: (response: Result<string>) => {
                props.onCloseDialog();

                if (response.success()) {
                    props.onDeletion();
                    snackbar.show(createElement(Trans, { i18nKey: "dataDeleted", values: { name: props.observationName } }));
                }
            },
        });
    };

    async function remove() {
        return await deleteHttp<string>(`/observations/${props.observationId}`);
    }

    return {
        removeObservation,
        inProgress: removeMutation.isLoading,
    };
}
